<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ ModalTitle }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseClick()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-attendance-summary-edit [Date]="Date" [employee]="employee" [attendanceList]="attendanceList"
                    [clockifyList]="clockifyList" *ngIf="activateAddEditAttendance">
                </app-attendance-summary-edit>
            </div>
        </div>
    </div>
</div>
<div class="col-md-12">
    <div class="card" style="border-radius: 0.5rem">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="container-fluid">
                        <div class="d-flex justify-content-center align-items-center">
                            <h2 style="margin-top: 1%;">
                                Upload a recent attendance sheet here
                            </h2>
                            <div class="input-group col-sm-4">
                                <div class="custom-file">
                                    <input class="form-control-file custom-file-input" id="inputGroupFile04" type="file"
                                        #fileInput (change)="updateFileName($event)" />
                                    <label class="custom-file-label" id="inputGroupFile04_label" for="inputGroupFile04">
                                        {{fileName}} </label>
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-success btn-sm" type="button" (click)="UploadFile()">
                                        Upload
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showProgressBar">
                <p class="text-center">Data import in progress. Please be patient.</p>
                <p><ngb-progressbar [value]="progressBarValue"></ngb-progressbar></p>
            </div>
            <div class="d-flex justify-content-center">
                <p *ngIf="dateLastImported && dateLastImportedFor"><small>Data was last imported on:
                        <b>{{dateLastImported | date: 'mediumDate'}}</b> for
                        <b>{{dateLastImportedFor | date: 'MMMM YYYY'}}</b></small></p>
            </div>
        </div>
    </div>
</div>
<div class="col-md-12">
    <div class="card" style="border-radius: 0.5rem">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="container-fluid">
                        <div class='row'>
                            <div class='col-4 small'>
                                <div class='font-weight-bold'>Table Legend</div>
                                <div class='font-weight-lighter font-italic'>Hover over icons in the table for more info
                                </div>
                                <ul class='list-group list-group-flush'>
                                    <li class="list-group-item p-1">
                                        <i style="color:green" class="fas fa-check px-1 mt-1"></i>
                                        All is fine.
                                    </li>
                                    <li class="list-group-item p-1">
                                        <i style="color:rgb(255, 170, 0)" class="fas fa-clock px-1 mt-1"></i>
                                        employee either worked a half day or a quarter day.
                                    </li>
                                    <li class="list-group-item p-1">
                                        <i style="color:rgb(189, 0, 0)" class="fas fa-exclamation px-1 mt-1"></i>
                                        Non-Technical employee came to office on a weekend.
                                    </li>
                                    <li class="list-group-item p-1">
                                        <i style="color:rgb(189, 0, 0)" class="fas fa-times fa-lg px-1 mt-1"></i>
                                        Unmarked employee leave.
                                    </li>
                                    <li class="list-group-item p-1">
                                        <i style="color:green" class="fas fa-check-circle px-1 mt-1"></i>
                                        A leave that has been marked.
                                    </li>
                                    <li class="list-group-item p-1">
                                        <i style="color:rgb(189, 0, 0)"
                                            class="fas fa-exclamation-triangle px-1 mt-1"></i>
                                        Data missing or discrepancy in data.
                                    </li>
                                    <li class="list-group-item p-1">
                                        <i style="color:black; margin-right: 2px;"
                                            class="fas fa-times fa-lg px-1 mt-1"></i>
                                        Public Holiday.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <h1 class="mb-0 d-flex">
                                <div class="mr-1" style="align-content: center; margin-top: 0.6%;">
                                    Showing attendance summary for the month of
                                </div>
                                <div class="btn-group">
                                    <div class="dropdown">
                                        <h1 class="btn-outline-dark btn-sm dropdown-toggle" role="button"
                                            id="dropdownMonth" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            {{ month }}
                                        </h1>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMonth">
                                            <button *ngFor="let item of monthDropdown" class="dropdown-item"
                                                type="button" (click)="UpdateMonth(item.Value, item.Text)">
                                                {{ item.Text }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="dropdown">
                                        <h1 class="btn-outline-dark btn-sm dropdown-toggle" role="button"
                                            id="dropdownYear" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            {{ year }}
                                        </h1>
                                        <div class="dropdown-menu" aria-labelledby="dropdownYear">
                                            <button *ngFor="let item2 of yearDropdown" class="dropdown-item"
                                                type="button" (click)="UpdateYear(item2)">
                                                {{ item2 }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </h1>
                            <div class="row">
                                <div hidden class="">
                                    <app-calculate-leaves #calcLeaves [attendanceList]="attendanceList"
                                        [employeeList]="employeeList" [monthList]="monthList"
                                        [clockifyList]="clockifyList" [monthNum]="monthNum" [year]="year">
                                    </app-calculate-leaves>
                                </div>
                                <div class="mr-3">
                                    <app-leave-summary [employee]="employee" [attendanceList]="attendanceList"
                                        [employeeList]="employeeList" [leaveList]="leaveList" [monthList]="monthList"
                                        [clockifyList]="clockifyList" [monthNum]="monthNum" [year]="year">
                                    </app-leave-summary>
                                </div>
                            </div>
                        </div>
                        <!-- <button (click)="Test()"></button> -->
                        <div class="w-100 scroll">
                            <table class="table table-striped table-sm table-hover mb-4" ng-if="columnsReady">
                                <thead class="thead-dark">
                                    <tr>
                                        <th class="sticky-row first-row text-left">Name</th>
                                        <th style="padding: 0px !important;" class="text-center sticky-row first-row"
                                            *ngFor="let Date of monthList">
                                            <div class="wid-10">{{ Date.pkDate | date: 'd' }}</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let employee of employeeList">
                                        <td class="text-left"> {{ employee.FirstName }} </td>
                                        <td *ngFor="let Day of monthList">
                                            <div class="wid-10"
                                                [ngSwitch]="CheckDayAndEmployee(Day.pkDate, employee.pkEmpId, employee.ClockifyId)">
                                                <!-- tick -->
                                                <div *ngSwitchCase="1" class="text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button style="background-color:transparent;" class="border-0">
                                                        <i style="color:green" class="fas fa-check"></i>
                                                        <!-- &#10004; -->
                                                    </button>
                                                </div>
                                                <!-- red cross -->
                                                <div *ngSwitchCase="2" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working Day - {{employee.FirstName}} absent">
                                                        <i style="color:rgb(189, 0, 0)" class="fas fa-times fa-lg"></i>
                                                        <!-- &#10060; -->
                                                    </button>
                                                </div>
                                                <!-- green tick for marked leave -->
                                                <div *ngSwitchCase="20" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working Day - {{employee.FirstName}} absent - Leave marked">
                                                        <i style="color:green" class="fas fa-check-circle fa-lg"></i>
                                                        <!-- &#10060; -->
                                                    </button>
                                                </div>
                                                <!-- grey cross | weekend -->
                                                <div *ngSwitchCase="3" class=" text-center">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" disabled>
                                                        &#10006;
                                                    </button>
                                                </div>
                                                <!-- black cross | holiday -->
                                                <div *ngSwitchCase="30" class=" text-center">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Holiday - {{Day.HolidayName}}">
                                                        <i style="color:black" class="fas fa-times fa-lg"></i>
                                                    </button>
                                                </div>
                                                <!-- exclamation -->
                                                <div *ngSwitchCase="4" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Weekend - {{employee.FirstName}} worked">
                                                        <i style="color:rgb(189, 0, 0)"
                                                            class="fas fa-exclamation fa-md"></i>
                                                        <!-- &#10071; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="5" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="{{employee.FirstName}} worked half of the day">
                                                        <i style="color:rgb(255, 196, 0)"
                                                            class="fas fa-clock fa-lg"></i> <!-- &#8987; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="6" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="{{employee.FirstName}} worked quarter of the day">
                                                        <i style="color:rgb(255, 123, 0)"
                                                            class="fas fa-clock fa-lg"></i> <!-- &#8987; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="7" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="{{employee.FirstName}} worked half of the day">
                                                        <i style="color:rgb(255, 196, 0)"
                                                            class="fas fa-clock fa-lg"></i>
                                                        <!-- &#8987; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="8" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="{{employee.FirstName}} worked quarter of the day">
                                                        <i style="color:rgb(255, 123, 0)"
                                                            class="fas fa-clock fa-lg"></i> </button>
                                                </div>
                                                <!-- warning -->
                                                <div *ngSwitchCase="0" class=" text-center"
                                                    (click)="Click(Day, employee)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working Day - {{employee.FirstName}} swiped card only once">
                                                        <i style="color:rgb(189, 0, 0)"
                                                            class="fas fa-exclamation-triangle fa-lg"></i>
                                                        <!-- &#9888; -->
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>